import { Field, Select } from '@/design-system';

import { reportCopy } from '../copy';

const copy = reportCopy.clientLanguage;

export interface ClientLanguageFieldProps {
    /** `report.clientLanguages`: Nederlands eerst, en de talen waarin de server vertaalt. */
    languages: readonly string[];
    value: string;
    onChange: (language: string) => void;
    disabled?: boolean;
}

/**
 * "Taal voor de klant" in een verstuurdialoog: de taal van de mail aan de klant en
 * van de klantpagina achter de link.
 *
 * Alleen als er iets te kiezen is: zolang de server niet vertaalt (geen
 * vertaalsleutel), staat er alleen Nederlands en vraagt de dialoog niets.
 */
export function ClientLanguageField({
    languages,
    value,
    onChange,
    disabled = false,
}: ClientLanguageFieldProps) {
    if (languages.length < 2) {
        return null;
    }

    return (
        <Field
            className="mt-[14px] max-w-[420px]"
            label={copy.label}
            description={copy.description}
        >
            <Select
                size="md"
                value={value}
                disabled={disabled}
                onChange={(event) => onChange(event.target.value)}
            >
                {languages.map((language) => (
                    <option key={language} value={language}>
                        {`${language.toUpperCase()} · ${copy.names[language] ?? language}`}
                    </option>
                ))}
            </Select>
        </Field>
    );
}
